/* Collection page: brand buttons, filters, sorting and counts. Works on the watches rendered on the page. Sold-out watches always stay last. */
(() => {
  function setup(root) {
    if (root.__cv) return;
    root.__cv = true;
    const cfgEl = root.querySelector('[data-cv-cfg]');
    const grid = root.querySelector('[data-cv-grid]');
    if (!cfgEl || !grid) return;
    const cfg = JSON.parse(cfgEl.textContent);
    const T = cfg.text;
    const $ = (sel) => root.querySelector(sel);
    const items = [...grid.querySelectorAll('[data-cv-item]')].map((el) => ({
      el,
      brand: el.dataset.brand || '',
      cents: +el.dataset.cents,
      type: el.dataset.type || '',
      size: el.dataset.size === '' ? null : parseFloat(el.dataset.size),
      avail: el.dataset.avail === '1',
      added: +el.dataset.new || 0,
      order: +el.dataset.order || 0,
    }));
    const state = { brand: '', price: [], type: [], size: [], instock: false, sort: 'feat' };

    const num = (n) => String(Math.round(n * 10) / 10);
    const ranges = (steps, fmt) => {
      const out = [];
      steps.forEach((s, i) => {
        const lo = i === 0 ? -Infinity : steps[i - 1];
        out.push({ lo, hi: s, label: i === 0 ? T.under.replace('[max]', fmt(s)) : T.between.replace('[min]', fmt(steps[i - 1])).replace('[max]', fmt(s)) });
      });
      if (steps.length) out.push({ lo: steps[steps.length - 1], hi: Infinity, label: T.over.replace('[min]', fmt(steps[steps.length - 1])) });
      return out;
    };
    const priceRanges = ranges(cfg.price, (n) => cfg.symbol + n);
    const sizeRanges = ranges(cfg.size, (n) => n + ' ' + T.mm);
    const inRange = (r, v) => v >= r.lo && v < r.hi;

    // Brands that really appear on this page, in the order of the brand list.
    const present = [...new Set(items.map((i) => i.brand).filter(Boolean))];
    const brandOrder = cfg.brands.map((b) => b.trim()).filter(Boolean);
    const brands = present.sort((a, b) => {
      const ia = brandOrder.findIndex((x) => x.toLowerCase() === a.toLowerCase());
      const ib = brandOrder.findIndex((x) => x.toLowerCase() === b.toLowerCase());
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    });

    const types = [...new Set(items.map((i) => i.type).filter(Boolean))];
    const withSize = items.filter((i) => i.size !== null && !isNaN(i.size)).length;

    function match(i, skip) {
      if (state.brand && i.brand !== state.brand) return false;
      if (state.instock && !i.avail) return false;
      if (skip !== 'price' && state.price.length && !state.price.some((k) => inRange(priceRanges[k], i.cents / 100))) return false;
      if (skip !== 'type' && state.type.length && !state.type.includes(types.indexOf(i.type))) return false;
      if (skip !== 'size' && state.size.length && !(i.size !== null && state.size.some((k) => inRange(sizeRanges[k], i.size)))) return false;
      return true;
    }

    // Brand buttons (two or more brands on the page)
    const brandRow = $('[data-cv-brands]');
    if (brandRow && brands.length <= 1) { brandRow.hidden = true; brandRow.classList.remove('is-pending'); }
    if (brandRow && brands.length > 1) {
      brandRow.hidden = false;
      brandRow.classList.remove('is-pending');
      const all = [''].concat(brands);
      const logo = (b) => {
        const tpl = [...root.querySelectorAll('template[data-cv-logo]')].find((x) => x.dataset.cvLogo.toLowerCase() === b.toLowerCase());
        return tpl && tpl.content.querySelector('img') ? tpl.innerHTML : null;
      };
      brandRow.innerHTML = all
        .map((b) => {
          const html = b === '' ? null : logo(b);
          const label = b === '' ? T.allBrands : b;
          return '<button type="button" data-b="' + b.replace(/"/g, '&quot;') + '" aria-pressed="' + (b === '') + '"' + (html ? ' class="has-logo" aria-label="' + label.replace(/"/g, '&quot;') + '"' : '') + '>' + (html || label) + '</button>';
        })
        .join('');
      brandRow.addEventListener('click', (e) => {
        const btn = e.target.closest('button');
        if (!btn) return;
        state.brand = btn.dataset.b;
        [...brandRow.children].forEach((x) => x.setAttribute('aria-pressed', x === btn));
        render();
      });
    }

    // Filter groups
    const filters = $('[data-cv-filters]');
    const groups = [
      { key: 'price', list: priceRanges.map((r) => r.label), show: priceRanges.length > 1 },
      { key: 'type', list: types, show: types.length > 1 },
      { key: 'size', list: sizeRanges.map((r) => r.label), show: withSize > 1 && sizeRanges.length > 1 },
    ];
    filters.hidden = false;
    filters.classList.add('is-ready');
    groups.forEach((g) => {
      const box = filters.querySelector('[data-cv-group="' + g.key + '"]');
      if (!box) return;
      box.hidden = !g.show;
      box.querySelector('[data-cv-list]').innerHTML = g.list
        .map((lab, i) => '<label><span><input type="checkbox" data-k="' + g.key + '" value="' + i + '">' + lab + '</span><small data-c="' + g.key + i + '"></small></label>')
        .join('');
    });

    // Phones and tablets: the filters open as a panel from the bottom. Wide screens: always visible beside the watches.
    const toggle = $('[data-cv-ftoggle]');
    const scrim = $('[data-cv-scrim]');
    const closeBtn = $('[data-cv-close]');
    const apply = $('[data-cv-apply]');
    toggle.hidden = false;
    const wide = window.matchMedia('(min-width: 901px)');
    let lastFocus = null;
    function setOpen(open) {
      filters.classList.toggle('open', open);
      scrim.hidden = !open;
      toggle.setAttribute('aria-expanded', open);
      document.documentElement.classList.toggle('cv-coll-lock', open);
      if (open) {
        lastFocus = document.activeElement;
        filters.setAttribute('role', 'dialog');
        filters.setAttribute('aria-modal', 'true');
        filters.setAttribute('aria-labelledby', filters.querySelector('.cv-coll__sheethead h2').id);
        requestAnimationFrame(() => (closeBtn || filters).focus());
      } else {
        filters.removeAttribute('role');
        filters.removeAttribute('aria-modal');
        filters.removeAttribute('aria-labelledby');
        if (lastFocus && lastFocus.focus && !wide.matches) lastFocus.focus();
      }
    }
    toggle.addEventListener('click', () => setOpen(!filters.classList.contains('open')));
    if (closeBtn) closeBtn.addEventListener('click', () => setOpen(false));
    if (apply) apply.addEventListener('click', () => setOpen(false));
    scrim.addEventListener('click', () => setOpen(false));
    document.addEventListener('keydown', (e) => {
      if (!filters.classList.contains('open')) return;
      if (e.key === 'Escape') setOpen(false);
      if (e.key === 'Tab') { // keep focus inside the panel
        const f = [...filters.querySelectorAll('button, input')].filter((x) => x.offsetParent !== null);
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    const sync = () => {
      toggle.style.display = wide.matches ? 'none' : '';
      if (wide.matches && filters.classList.contains('open')) setOpen(false);
    };
    sync();
    wide.addEventListener('change', sync);

    // Sticky positions: the header stays put on this page, so the toolbar and the filters sit just below its real height.
    const bar = $('.cv-coll__bar');
    const headerEl = document.querySelector('.section-header');
    const measure = () => {
      const h = headerEl ? Math.round(headerEl.getBoundingClientRect().height) : 0;
      root.style.setProperty('--cv-hdr', h + 'px');
      root.style.setProperty('--cv-bar', (bar ? bar.offsetHeight : 60) + 'px');
    };
    measure();
    if (window.ResizeObserver) {
      const ro = new ResizeObserver(measure);
      if (headerEl) ro.observe(headerEl);
      if (bar) ro.observe(bar);
    }
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);

    function render() {
      const list = items.filter((i) => match(i));
      const s = state.sort;
      const sorted = list.slice().sort((a, b) => {
        if (a.avail !== b.avail) return a.avail ? -1 : 1;
        return s === 'low' ? a.cents - b.cents : s === 'high' ? b.cents - a.cents : s === 'new' ? b.added - a.added : a.order - b.order;
      });
      const shown = new Set(list);
      items.forEach((i) => { i.el.hidden = !shown.has(i); });
      sorted.forEach((i) => grid.appendChild(i.el));
      const empty = $('[data-cv-empty]');
      if (empty) empty.hidden = list.length > 0;
      $('[data-cv-count]').textContent = (list.length === 1 ? T.one : T.many).replace('[n]', list.length);
      if (apply) apply.textContent = (list.length === 1 ? T.applyOne : T.applyMany).replace('[n]', list.length);

      groups.forEach((g) => {
        g.list.forEach((_, i) => {
          const n = items.filter((it) => {
            if (!match(it, g.key)) return false;
            const save = state[g.key];
            state[g.key] = [i];
            const ok = match(it);
            state[g.key] = save;
            return ok;
          }).length;
          const el = filters.querySelector('[data-c="' + g.key + i + '"]');
          if (el) el.textContent = n;
        });
      });
      const f = state.price.length + state.type.length + state.size.length + (state.instock ? 1 : 0);
      const badge = $('[data-cv-fcount]');
      badge.hidden = !f;
      badge.textContent = f;
    }

    root.addEventListener('change', (e) => {
      const t = e.target;
      if (t.matches('[data-cv-instock]')) state.instock = t.checked;
      else if (t.dataset.k) {
        const a = state[t.dataset.k];
        const v = +t.value;
        if (t.checked) a.push(v); else a.splice(a.indexOf(v), 1);
      } else if (t.matches('[data-cv-sort]')) state.sort = t.value;
      else return;
      render();
    });
    root.addEventListener('click', (e) => {
      if (!e.target.closest('[data-cv-clear]')) return;
      state.price = []; state.type = []; state.size = []; state.instock = false;
      filters.querySelectorAll('input').forEach((i) => { i.checked = false; });
      render();
    });
    render();
  }

  const init = (scope = document) => scope.querySelectorAll('[data-cv-coll]').forEach(setup);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  init();
})();
